var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStackedBarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_576)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.7499 1.5199H1.1499V5.99567H5.7499V1.5199Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7499 5.99567H1.1499V11.1216H5.7499V5.99567Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 7.5199H9.19995V11.4559H13.8V7.5199Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 3.75778H17.25V7.5199H21.85V3.75778Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 7.5199H17.25V12.6458H21.85V7.5199Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.7499 11.1216H1.1499V21.5199H5.7499V11.1216Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8 7.5199H9.19995V21.5199H13.8V7.5199Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.85 3.5199H17.25V21.5199H21.85V3.5199Z",
    stroke: "#A3AAB3",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_576"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white",
    transform: "translate(0 0.0198975)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackedBarIcon);
export default __webpack_public_path__ + "static/media/stackedBarIcon.706e1cadce9f5deed310ca7101bc9624.svg";
export { ForwardRef as ReactComponent };